import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  max-width: 636px;
  width: 100%;
  padding-top: 48px;
  box-sizing: border-box;
`;
